import useiCloudReady from '../../hooks/useiCloudReady'
import React from 'react'
import { CallToAction, CTAPropsType } from '../CallToAction'

export interface TrackedCTAPropsType extends CTAPropsType {
    event: {
        name: string
        [key: string]: any
    }
}

export const TrackedCTA = ({ event: { name: eventName, ...event }, ...props }: TrackedCTAPropsType): JSX.Element => {
    const icloudready = useiCloudReady()

    return (
        <CallToAction
            {...props}
            onClick={() => {
                icloudready?.capture(eventName, event)
                props.onClick && props.onClick()
            }}
        />
    )
}
